module.exports = "https://trybtryb-legacy.web.app/img/ignite-potential.b60463f1.webp";